/* unplugin-vue-components disabled */import script from "./ConfirmWord.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConfirmWord.vue?vue&type=script&lang=ts&setup=true"

import "./ConfirmWord.vue?vue&type=style&index=0&id=34914efc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34914efc"]])

export default __exports__